import { BaseCaller } from './api';
import { Client } from './model';

export default class ClientApi {

    private caller: BaseCaller;

    constructor(caller: BaseCaller) {
        this.caller = caller;
    }

    public list(): Promise<any> {

        return this.caller.get(`client/`);

    };
    public listPaginate(page: number = 0, pageSize: number = 5, search?: string): Promise<any> {
        if (search !== '') {
            return this.caller.get(`client/${page}/${pageSize}?search=${search}`);
        } else {
            if (search === '') {
                return this.caller.get(`client/${page}/${pageSize}`);
            }
            else {
                return this.caller.get(`client/`);
            }
        }
    };


    add(data: { name: string; document: string; email: string }) {
        return this.caller.post('client/', data);
    }
    addLocation(data: any) {
        return this.caller.post('location/addExternalClientLocation/', data);
    }

    public byId(id: number): Promise<Client> {
        return this.caller.get(`client/${id}`);
    }

    public update(id: number, data: object) {
        return this.caller.put(`client/${id}`, data);
    }

    locations(page: number = 1, pageSize: number = 5, searchName: string, searchDir: string) {
        if (searchName !== '' && searchDir !== '') {
            return this.caller.get(`location/${page}/${pageSize}?searchName=${searchName}&searchDir=${searchDir}`);
        } else {
            if (searchName !== '') {
                return this.caller.get(`location/${page}/${pageSize}?searchName=${searchName}`);
            }
            else if (searchDir !== '') {
                return this.caller.get(`location/${page}/${pageSize}?searchDir=${searchDir}`);
            }
            else {
                return this.caller.get(`location/${page}/${pageSize}`);
            }
        }
    }
    // locations() {
    //     return this.caller.get(`location`);
    // }

}



// WEBPACK FOOTER //
// ./src/api/client-api.ts